import React from 'react'
import styled from 'styled-components'
import { Modal } from 'vqp-common'
import { Button } from './Button'

const ModalContent = styled.div`
  padding: 24px;
  min-width: 320px;
`

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${(p) => p.theme.colors?.textBold || '#333'};
  margin: 0 0 12px 0;
  padding-bottom: 12px;
  border-bottom: 1px solid ${(p) => p.theme.colors?.lineGrey || '#e8e8e8'};
`

const Message = styled.p`
  font-size: 14px;
  color: ${(p) => p.theme.colors?.textPrimary || '#555'};
  margin: 0 0 11px 0;
  line-height: 1.5;
  text-align: center;
`

const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid ${(p) => p.theme.colors?.lineGrey || '#e8e8e8'};

  & > button {
    min-width: 100px;
    height: 36px;
  }
`

export const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirmar',
  message = 'Tem certeza?',
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  variant = 'danger',
}) => {
  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} boxWidth="400px">
      <ModalContent>
        <ModalTitle>{title}</ModalTitle>
        <Message>{message}</Message>
        <Actions>
          <Button onClick={onClose}>{cancelLabel}</Button>
          <Button className={variant === 'danger' ? 'error' : 'primary'} onClick={handleConfirm}>
            {confirmLabel}
          </Button>
        </Actions>
      </ModalContent>
    </Modal>
  )
}
